import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import SkillDashboard from '../SkillDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';
import SkillPageImpl from './SkillPageImpl';

export default function SkillPage() {
    const dispatch = useDispatch();
    const { skillList} = useSelector((state)=>state.manufslice)
    useEffect(() => {
        dispatch(openDrawer({'drawerOpen':true}));
    },[]);

    return (
        < SkillPageImpl />
    )

}